// extracted by mini-css-extract-plugin
export default {"section":"OrderList_section__9+kph","list":"OrderList_list__Szc28","article__container":"OrderList_article__container__7LyuB"};